import request from './request'

export function fetchShopCategoryList(params) {
  return request({ url: '/admin/shopcategory/list', method: 'get', params })
}

export function fetchShopCategoryAll() {
  return request({ url: '/admin/shopcategory/all', method: 'get' })
}

export function saveShopCategory(data) {
  return request({ url: '/admin/shopcategory/save', method: 'post', data })
}

export function deleteShopCategory(data) {
  return request({ url: '/admin/shopcategory/delete', method: 'post', data })
}

export function updateShopCategoryStatus(data) {
  return request({ url: '/admin/shopcategory/updateStatus', method: 'post', data })
}

export function fetchShopGameList(params) {
  return request({ url: '/admin/shopgame/list', method: 'get', params })
}

export function saveShopGame(data) {
  return request({ url: '/admin/shopgame/save', method: 'post', data })
}

export function deleteShopGame(data) {
  return request({ url: '/admin/shopgame/delete', method: 'post', data })
}

export function updateShopGameStatus(data) {
  return request({ url: '/admin/shopgame/updateStatus', method: 'post', data })
}

export function fetchShopProductList(params) {
  return request({ url: '/admin/shopproduct/list', method: 'get', params })
}

export function fetchShopProductDetail(params) {
  return request({ url: '/admin/shopproduct/detail', method: 'get', params })
}

export function saveShopProduct(data) {
  return request({ url: '/admin/shopproduct/save', method: 'post', data })
}

export function deleteShopProduct(data) {
  return request({ url: '/admin/shopproduct/delete', method: 'post', data })
}

export function updateShopProductStatus(data) {
  return request({ url: '/admin/shopproduct/updateStatus', method: 'post', data })
}

export function fetchShopOrderList(params) {
  return request({ url: '/admin/shoporder/list', method: 'get', params })
}

export function fetchShopOrderUnreadCount() {
  return request({
    url: '/admin/shoporder/unreadCount',
    method: 'get',
    hideLoading: true,
    silent: true
  })
}

export function updateShopOrderStatus(data) {
  return request({ url: '/admin/shoporder/updateStatus', method: 'post', data })
}

export function deleteShopOrder(data) {
  return request({ url: '/admin/shoporder/delete', method: 'post', data })
}

export function fetchShopCommissionList(params) {
  return request({ url: '/admin/shopcommission/list', method: 'get', params })
}

export function fetchShopCommissionBloggerOptions() {
  return request({ url: '/admin/shopcommission/bloggerOptions', method: 'get' })
}

export function settleShopCommission(data) {
  return request({ url: '/admin/shopcommission/settle', method: 'post', data })
}

export function rebuildShopCommission() {
  return request({ url: '/admin/shopcommission/rebuild', method: 'post' })
}

export function fetchShopAddressList(params) {
  return request({ url: '/admin/shopaddress/list', method: 'get', params })
}

export function deleteShopAddress(data) {
  return request({ url: '/admin/shopaddress/delete', method: 'post', data })
}

export function fetchPointsLogList(params) {
  return request({ url: '/admin/pointslog/list', method: 'get', params })
}

export function fetchShopStatsOverview() {
  return request({ url: '/admin/shopstats/overview', method: 'get' })
}

export function fetchShopBusinessSetting(params) {
  return request({ url: '/admin/shopsetting/detail', method: 'get', params })
}

export function saveShopBusinessSetting(data) {
  return request({ url: '/admin/shopsetting/save', method: 'post', data })
}
